import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPlus,
    faEdit,
    faTrash,
    faSearch,
    faSync,
    faMapMarkerAlt,
    faBuilding,
    faUserTie,
    faTimes,
    faSave,
    faGlobeAmericas,
    faLayerGroup,
    faClock
} from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './CentrosServiciosData.css';

export default function CentrosServiciosData() {
    // Pestaña activa ('centros' o 'zonas')
    const [activeTab, setActiveTab] = useState('centros');

    // ==========================================
    // ESTADOS: CENTROS
    // ==========================================
    const [centros, setCentros] = useState([]);
    const [loadingCentros, setLoadingCentros] = useState(true);
    const [filtroTexto, setFiltroTexto] = useState('');
    const [filtroZona, setFiltroZona] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const centrosPorPagina = 10;

    // Modal Crear Centro
    const [modalCrear, setModalCrear] = useState(false);
    const [nuevoNro, setNuevoNro] = useState('');
    const [nuevoCodigo, setNuevoCodigo] = useState('');
    const [nuevoDirector, setNuevoDirector] = useState('');
    const [nuevaZona, setNuevaZona] = useState('');
    const [nuevaCiudad, setNuevaCiudad] = useState('');
    const [nuevaUbicacion, setNuevaUbicacion] = useState('');
    const [nuevoContacto, setNuevoContacto] = useState('');
    const [nuevoHorario, setNuevoHorario] = useState('');
    const [guardandoCentro, setGuardandoCentro] = useState(false);

    // Modal Editar Centro
    const [modalEditar, setModalEditar] = useState(false);
    const [centroEditando, setCentroEditando] = useState(null);
    const [editNro, setEditNro] = useState('');
    const [editCodigo, setEditCodigo] = useState('');
    const [editDirector, setEditDirector] = useState('');
    const [editZona, setEditZona] = useState('');
    const [editCiudad, setEditCiudad] = useState('');
    const [editUbicacion, setEditUbicacion] = useState('');
    const [editContacto, setEditContacto] = useState('');
    const [editHorario, setEditHorario] = useState('');
    const [actualizandoCentro, setActualizandoCentro] = useState(false);

    // ==========================================
    // ESTADOS: ZONAS
    // ==========================================
    const [zonas, setZonas] = useState([]);
    const [loadingZonas, setLoadingZonas] = useState(true);
    const [filtroZonaTexto, setFiltroZonaTexto] = useState('');

    // Modal Crear Zona
    const [modalCrearZona, setModalCrearZona] = useState(false);
    const [nombreNuevaZona, setNombreNuevaZona] = useState('');
    const [guardandoZona, setGuardandoZona] = useState(false);

    // Modal Editar Zona
    const [modalEditarZona, setModalEditarZona] = useState(false);
    const [zonaEditando, setZonaEditando] = useState(null);
    const [nombreEditZona, setNombreEditZona] = useState('');
    const [actualizandoZona, setActualizandoZona] = useState(false);

    useEffect(() => {
        cargarCentros();
        cargarZonas();
    }, []);

    // ==========================================
    // CARGAS DE DATOS
    // ==========================================
    const cargarCentros = () => {
        setLoadingCentros(true);
        fetch(`${baseURL}/centrosServiciosGet.php`, {
            method: 'GET',
            credentials: 'include'
        })
            .then(res => res.json())
            .then(data => {
                setCentros(data.centros || []);
                setLoadingCentros(false);
            })
            .catch(err => {
                console.error('Error al cargar centros:', err);
                toast.error('Error al conectar con la lista de centros');
                setLoadingCentros(false);
            });
    };

    const cargarZonas = () => {
        setLoadingZonas(true);
        fetch(`${baseURL}/zonasCentrosGet.php`, {
            method: 'GET',
            credentials: 'include'
        })
            .then(res => res.json())
            .then(data => {
                const listaZonas = data.zonas || [];
                setZonas(listaZonas);
                if (listaZonas.length > 0 && !nuevaZona) {
                    setNuevaZona(listaZonas[0].nombre_zona);
                }
                setLoadingZonas(false);
            })
            .catch(err => {
                console.error('Error al cargar zonas:', err);
                toast.error('Error al cargar zonas');
                setLoadingZonas(false);
            });
    };

    // ==========================================
    // CRUD: CENTROS
    // ==========================================
    const handleCrearCentro = async (e) => {
        e.preventDefault();
        if (!nuevoCodigo.trim() || !nuevoDirector.trim() || !nuevaUbicacion.trim()) {
            toast.error('Complete los campos obligatorios: Código, Director y Ubicación.');
            return;
        }

        const zonaFinal = nuevaZona || (zonas[0] ? zonas[0].nombre_zona : 'Lima - Centro');

        setGuardandoCentro(true);
        try {
            const formData = new FormData();
            formData.append('nro', nuevoNro);
            formData.append('codigo', nuevoCodigo.trim());
            formData.append('nombre_director', nuevoDirector.trim());
            formData.append('zona', zonaFinal);
            formData.append('ciudad', nuevaCiudad.trim());
            formData.append('ubicacion', nuevaUbicacion.trim());
            formData.append('contacto', nuevoContacto.trim());
            formData.append('horario', nuevoHorario.trim());

            const res = await fetch(`${baseURL}/centrosServicioPost.php`, {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            const data = await res.json();
            if (res.ok) {
                toast.success('Centro de servicio creado exitosamente');
                setModalCrear(false);
                limpiarFormCrearCentro();
                cargarCentros();
                cargarZonas();
            } else {
                toast.error(data.error || 'Error al guardar el centro');
            }
        } catch (err) {
            console.error('Error al crear centro:', err);
            toast.error('Error en el servidor');
        } finally {
            setGuardandoCentro(false);
        }
    };

    const limpiarFormCrearCentro = () => {
        setNuevoNro('');
        setNuevoCodigo('');
        setNuevoDirector('');
        setNuevaZona(zonas[0] ? zonas[0].nombre_zona : '');
        setNuevaCiudad('');
        setNuevaUbicacion('');
        setNuevoContacto('');
        setNuevoHorario('');
    };

    const abrirModalEditarCentro = (centro) => {
        setCentroEditando(centro);
        setEditNro(centro.nro || '');
        setEditCodigo(centro.codigo || '');
        setEditDirector(centro.nombre_director || '');
        setEditZona(centro.zona || (zonas[0] ? zonas[0].nombre_zona : ''));
        setEditCiudad(centro.ciudad || '');
        setEditUbicacion(centro.ubicacion || '');
        setEditContacto(centro.contacto || '');
        setEditHorario(centro.horario || '');
        setModalEditar(true);
    };

    const handleEditarCentro = async (e) => {
        e.preventDefault();
        if (!editCodigo.trim() || !editDirector.trim() || !editUbicacion.trim()) {
            toast.error('Complete los campos obligatorios: Código, Director y Ubicación.');
            return;
        }

        setActualizandoCentro(true);
        try {
            const formData = new FormData();
            formData.append('idCentro', centroEditando.idCentro);
            formData.append('nro', editNro);
            formData.append('codigo', editCodigo.trim());
            formData.append('nombre_director', editDirector.trim());
            formData.append('zona', editZona);
            formData.append('ciudad', editCiudad.trim());
            formData.append('ubicacion', editUbicacion.trim());
            formData.append('contacto', editContacto.trim());
            formData.append('horario', editHorario.trim());

            const res = await fetch(`${baseURL}/centrosServicioPut.php`, {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            const data = await res.json();
            if (res.ok) {
                toast.success('Centro de servicio actualizado correctamente');
                setModalEditar(false);
                setCentroEditando(null);
                cargarCentros();
                cargarZonas();
            } else {
                toast.error(data.error || 'Error al actualizar el centro');
            }
        } catch (err) {
            console.error('Error al editar centro:', err);
            toast.error('Error en el servidor');
        } finally {
            setActualizandoCentro(false);
        }
    };

    const handleEliminarCentro = (centro) => {
        Swal.fire({
            title: '¿Eliminar este Centro?',
            text: `¿Desea eliminar el centro "${centro.nombre_director}" (Código: ${centro.codigo})?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const formData = new FormData();
                    formData.append('idCentro', centro.idCentro);

                    const res = await fetch(`${baseURL}/centrosServicioDelete.php`, {
                        method: 'POST',
                        body: formData,
                        credentials: 'include'
                    });

                    const data = await res.json();
                    if (res.ok) {
                        Swal.fire('¡Eliminado!', data.mensaje || 'Centro eliminado correctamente.', 'success');
                        cargarCentros();
                        cargarZonas();
                    } else {
                        toast.error(data.error || 'No se pudo eliminar el centro');
                    }
                } catch (err) {
                    console.error('Error al eliminar:', err);
                    toast.error('Error en el servidor');
                }
            }
        });
    };

    // ==========================================
    // CRUD: ZONAS
    // ==========================================
    const handleCrearZona = async (e) => {
        e.preventDefault();
        const zonaLimpia = nombreNuevaZona.trim();
        if (!zonaLimpia) {
            toast.error('Ingrese el nombre de la zona');
            return;
        }

        setGuardandoZona(true);
        try {
            const formData = new FormData();
            formData.append('nombre_zona', zonaLimpia);

            const res = await fetch(`${baseURL}/zonaCentroPost.php`, {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            const data = await res.json();
            if (res.ok) {
                toast.success('Zona creada exitosamente');
                setModalCrearZona(false);
                setNombreNuevaZona('');
                cargarZonas();
            } else {
                toast.error(data.error || 'Error al guardar la zona');
            }
        } catch (err) {
            console.error('Error al crear zona:', err);
            toast.error('Error en el servidor');
        } finally {
            setGuardandoZona(false);
        }
    };

    const abrirModalEditarZona = (z) => {
        setZonaEditando(z);
        setNombreEditZona(z.nombre_zona);
        setModalEditarZona(true);
    };

    const handleEditarZona = async (e) => {
        e.preventDefault();
        const zonaLimpia = nombreEditZona.trim();
        if (!zonaLimpia) {
            toast.error('El nombre de la zona no puede estar vacío');
            return;
        }

        setActualizandoZona(true);
        try {
            const formData = new FormData();
            formData.append('idZona', zonaEditando.idZona);
            formData.append('nombre_zona', zonaLimpia);

            const res = await fetch(`${baseURL}/zonaCentroPut.php`, {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            const data = await res.json();
            if (res.ok) {
                toast.success('Zona actualizada correctamente (los centros asociados fueron actualizados)');
                setModalEditarZona(false);
                setZonaEditando(null);
                cargarZonas();
                cargarCentros();
            } else {
                toast.error(data.error || 'Error al actualizar la zona');
            }
        } catch (err) {
            console.error('Error al actualizar zona:', err);
            toast.error('Error en el servidor');
        } finally {
            setActualizandoZona(false);
        }
    };

    const handleEliminarZona = (z) => {
        const cantCentros = parseInt(z.total_centros || 0, 10);
        let textoAlerta = `¿Desea eliminar la zona "${z.nombre_zona}"?`;
        if (cantCentros > 0) {
            textoAlerta += ` ¡Atención! Tiene ${cantCentros} centros de servicio asociados a esta zona.`;
        }

        Swal.fire({
            title: '¿Eliminar Zona?',
            text: textoAlerta,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const formData = new FormData();
                    formData.append('idZona', z.idZona);

                    const res = await fetch(`${baseURL}/zonaCentroDelete.php`, {
                        method: 'POST',
                        body: formData,
                        credentials: 'include'
                    });

                    const data = await res.json();
                    if (res.ok) {
                        Swal.fire('¡Eliminada!', data.mensaje || 'Zona eliminada correctamente.', 'success');
                        cargarZonas();
                    } else {
                        toast.error(data.error || 'No se pudo eliminar la zona');
                    }
                } catch (err) {
                    console.error('Error al eliminar zona:', err);
                    toast.error('Error en el servidor');
                }
            }
        });
    };

    // ==========================================
    // FILTROS Y PAGINACIÓN DE CENTROS
    // ==========================================
    const centrosFiltrados = centros.filter(c => {
        const coincideZona = !filtroZona || (c.zona && c.zona.toLowerCase().trim() === filtroZona.toLowerCase().trim());
        const textoBusqueda = filtroTexto.toLowerCase().trim();
        const coincideTexto = !textoBusqueda ||
            (c.nombre_director && c.nombre_director.toLowerCase().includes(textoBusqueda)) ||
            (c.codigo && c.codigo.toLowerCase().includes(textoBusqueda)) ||
            (c.ciudad && c.ciudad.toLowerCase().includes(textoBusqueda)) ||
            (c.ubicacion && c.ubicacion.toLowerCase().includes(textoBusqueda)) ||
            (c.contacto && c.contacto.toLowerCase().includes(textoBusqueda));

        return coincideZona && coincideTexto;
    });

    const totalPaginas = Math.ceil(centrosFiltrados.length / centrosPorPagina) || 1;
    const indiceInicio = (paginaActual - 1) * centrosPorPagina;
    const centrosPaginados = centrosFiltrados.slice(indiceInicio, indiceInicio + centrosPorPagina);

    // Zonas filtradas
    const zonasFiltradas = zonas.filter(z =>
        !filtroZonaTexto || z.nombre_zona.toLowerCase().includes(filtroZonaTexto.toLowerCase().trim())
    );

    return (
        <div className="centros-admin-wrapper">
            <ToastContainer />

            {/* Cabecera Principal */}
            <div className="centros-admin-header">
                <div className="header-info">
                    <h2>
                        <FontAwesomeIcon icon={faMapMarkerAlt} className="title-icon" /> Centros de Servicios DXN Perú
                    </h2>
                </div>

                <div className="header-actions">
                    <button
                        type="button"
                        className="btn-refresh"
                        onClick={() => { cargarCentros(); cargarZonas(); }}
                        title="Recargar información"
                    >
                        <FontAwesomeIcon icon={faSync} />
                    </button>
                    {activeTab === 'centros' ? (
                        <button
                            type="button"
                            className="btn-nuevo-centro"
                            onClick={() => setModalCrear(true)}
                        >
                            <FontAwesomeIcon icon={faPlus} /> Nuevo Centro
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="btn-nuevo-centro"
                            onClick={() => setModalCrearZona(true)}
                        >
                            <FontAwesomeIcon icon={faPlus} /> Nueva Zona
                        </button>
                    )}
                </div>
            </div>

            {/* Barra de Pestañas */}
            <div className="centros-tabs-nav">
                <button
                    type="button"
                    className={`tab-btn ${activeTab === 'centros' ? 'tab-activa' : ''}`}
                    onClick={() => setActiveTab('centros')}
                >
                    <FontAwesomeIcon icon={faBuilding} /> Centros de Servicios ({centros.length})
                </button>
                <button
                    type="button"
                    className={`tab-btn ${activeTab === 'zonas' ? 'tab-activa' : ''}`}
                    onClick={() => setActiveTab('zonas')}
                >
                    <FontAwesomeIcon icon={faLayerGroup} /> Zonas de Cobertura ({zonas.length})
                </button>
            </div>

            {/* ========================================================= */}
            {/* PESTAÑA 1: CENTROS DE SERVICIOS                          */}
            {/* ========================================================= */}
            {activeTab === 'centros' && (
                <div className="tab-pane">
                    {/* Barra de Filtros */}
                    <div className="centros-filtros-bar">
                        <div className="search-box">
                            <FontAwesomeIcon icon={faSearch} className="search-icon" />
                            <input
                                type="text"
                                placeholder="Buscar por director, código, ciudad, dirección o contacto..."
                                value={filtroTexto}
                                onChange={(e) => {
                                    setFiltroTexto(e.target.value);
                                    setPaginaActual(1);
                                }}
                            />
                            {filtroTexto && (
                                <button
                                    type="button"
                                    className="clear-search"
                                    onClick={() => setFiltroTexto('')}
                                >
                                    ✕
                                </button>
                            )}
                        </div>

                        <div className="filter-select-wrap">
                            <select
                                value={filtroZona}
                                onChange={(e) => {
                                    setFiltroZona(e.target.value);
                                    setPaginaActual(1);
                                }}
                            >
                                <option value="">Todas las Zonas ({zonas.length})</option>
                                {zonas.map(z => (
                                    <option key={z.idZona} value={z.nombre_zona}>
                                        {z.nombre_zona} ({z.total_centros || 0})
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Tabla de Centros */}
                    <div className="table-responsive-wrapper">
                        {loadingCentros ? (
                            <div className="loading-state">
                                <div className="spinner"></div>
                                <p>Cargando centros de servicios...</p>
                            </div>
                        ) : centrosFiltrados.length === 0 ? (
                            <div className="empty-state">
                                <FontAwesomeIcon icon={faBuilding} className="empty-icon" />
                                <h3>No se encontraron centros</h3>
                                <p>Pruebe con otros términos de búsqueda o seleccione otra zona.</p>
                            </div>
                        ) : (
                            <table className="tabla-centros">
                                <thead>
                                    <tr>
                                        <th style={{ width: '50px' }}>N°</th>
                                        <th style={{ width: '110px' }}>Código</th>
                                        <th style={{ width: '220px' }}>Director</th>
                                        <th style={{ width: '170px' }}>Zona / Ciudad</th>
                                        <th>Ubicación</th>
                                        <th style={{ width: '240px' }}>Contacto</th>
                                        <th style={{ width: '190px' }}>Horario</th>
                                        <th style={{ width: '100px', textAlign: 'center' }}>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {centrosPaginados.map((c) => (
                                        <tr key={c.idCentro}>
                                            <td className="col-nro">
                                                <span className="nro-pill">{c.nro || c.idCentro}</span>
                                            </td>
                                            <td>
                                                <span className="codigo-badge">{c.codigo}</span>
                                            </td>
                                            <td>
                                                <div className="director-name">
                                                    <FontAwesomeIcon icon={faUserTie} className="director-icon" />
                                                    <strong>{c.nombre_director}</strong>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="zona-text">{c.zona}</div>
                                                {c.ciudad && <span className="ciudad-tag">{c.ciudad}</span>}
                                            </td>
                                            <td className="col-ubicacion">
                                                <div className="ubicacion-text">
                                                    <FontAwesomeIcon icon={faMapMarkerAlt} className="marker-mini" />
                                                    {c.ubicacion}
                                                </div>
                                            </td>
                                            <td className="col-contacto">
                                                <div className="contacto-snippet">{c.contacto}</div>
                                            </td>
                                            <td className="col-horario">
                                                <div className="horario-snippet">
                                                    <FontAwesomeIcon icon={faClock} className="clock-mini" />
                                                    {c.horario}
                                                </div>
                                            </td>
                                            <td className="col-acciones">
                                                <div className="acciones-wrap">
                                                    <button
                                                        type="button"
                                                        className="btn-accion btn-editar"
                                                        onClick={() => abrirModalEditarCentro(c)}
                                                        title="Editar centro"
                                                    >
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn-accion btn-eliminar"
                                                        onClick={() => handleEliminarCentro(c)}
                                                        title="Eliminar centro"
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>

                    {/* Paginación */}
                    {centrosFiltrados.length > centrosPorPagina && (
                        <div className="paginacion-wrapper">
                            <span className="paginacion-info">
                                Mostrando {indiceInicio + 1} - {Math.min(indiceInicio + centrosPorPagina, centrosFiltrados.length)} de {centrosFiltrados.length} centros
                            </span>

                            <div className="paginacion-botones">
                                <button
                                    type="button"
                                    disabled={paginaActual === 1}
                                    onClick={() => setPaginaActual(p => Math.max(p - 1, 1))}
                                    className="btn-pag"
                                >
                                    &laquo; Anterior
                                </button>

                                {Array.from({ length: totalPaginas }, (_, i) => i + 1)
                                    .filter(p => p === 1 || p === totalPaginas || Math.abs(p - paginaActual) <= 2)
                                    .map((num, idx, arr) => (
                                        <React.Fragment key={num}>
                                            {idx > 0 && num - arr[idx - 1] > 1 && (
                                                <span className="pag-puntos">...</span>
                                            )}
                                            <button
                                                type="button"
                                                className={`btn-pag ${paginaActual === num ? 'activa' : ''}`}
                                                onClick={() => setPaginaActual(num)}
                                            >
                                                {num}
                                            </button>
                                        </React.Fragment>
                                    ))}

                                <button
                                    type="button"
                                    disabled={paginaActual === totalPaginas}
                                    onClick={() => setPaginaActual(p => Math.min(p + 1, totalPaginas))}
                                    className="btn-pag"
                                >
                                    Siguiente &raquo;
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {/* ========================================================= */}
            {/* PESTAÑA 2: ZONAS DE COBERTURA                            */}
            {/* ========================================================= */}
            {activeTab === 'zonas' && (
                <div className="tab-pane">
                    <div className="centros-filtros-bar">
                        <div className="search-box">
                            <FontAwesomeIcon icon={faSearch} className="search-icon" />
                            <input
                                type="text"
                                placeholder="Buscar zona..."
                                value={filtroZonaTexto}
                                onChange={(e) => setFiltroZonaTexto(e.target.value)}
                            />
                            {filtroZonaTexto && (
                                <button
                                    type="button"
                                    className="clear-search"
                                    onClick={() => setFiltroZonaTexto('')}
                                >
                                    ✕
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="table-responsive-wrapper">
                        {loadingZonas ? (
                            <div className="loading-state">
                                <div className="spinner"></div>
                                <p>Cargando zonas...</p>
                            </div>
                        ) : zonasFiltradas.length === 0 ? (
                            <div className="empty-state">
                                <FontAwesomeIcon icon={faGlobeAmericas} className="empty-icon" />
                                <h3>No se encontraron zonas</h3>
                                <p>Crea tu primera zona con el botón "+ Nueva Zona".</p>
                            </div>
                        ) : (
                            <table className="tabla-centros">
                                <thead>
                                    <tr>
                                        <th style={{ width: '60px' }}>ID</th>
                                        <th>Nombre de la Zona / Región</th>
                                        <th style={{ width: '220px', textAlign: 'center' }}>Centros Asociados</th>
                                        <th style={{ width: '120px', textAlign: 'center' }}>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {zonasFiltradas.map((z) => (
                                        <tr key={z.idZona}>
                                            <td>
                                                <span className="nro-pill">#{z.idZona}</span>
                                            </td>
                                            <td>
                                                <div className="zona-nombre-cell">
                                                    <FontAwesomeIcon icon={faLayerGroup} className="zona-icon" />
                                                    <strong>{z.nombre_zona}</strong>
                                                </div>
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <button
                                                    type="button"
                                                    className="centros-badge-btn"
                                                    title="Ver centros de esta zona"
                                                    onClick={() => {
                                                        setFiltroZona(z.nombre_zona);
                                                        setActiveTab('centros');
                                                    }}
                                                >
                                                    {z.total_centros || 0} centros
                                                </button>
                                            </td>
                                            <td className="col-acciones">
                                                <div className="acciones-wrap">
                                                    <button
                                                        type="button"
                                                        className="btn-accion btn-editar"
                                                        onClick={() => abrirModalEditarZona(z)}
                                                        title="Editar nombre de zona"
                                                    >
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn-accion btn-eliminar"
                                                        onClick={() => handleEliminarZona(z)}
                                                        title="Eliminar zona"
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            )}

            {/* ========================================================= */}
            {/* MODAL CREAR CENTRO                                        */}
            {/* ========================================================= */}
            {modalCrear && (
                <div className="modal-crud-overlay" onClick={() => setModalCrear(false)}>
                    <div className="modal-crud-content" onClick={e => e.stopPropagation()}>
                        <div className="modal-crud-header">
                            <h3><FontAwesomeIcon icon={faPlus} /> Agregar Nuevo Centro de Servicio</h3>
                            <button
                                type="button"
                                className="btn-close-modal"
                                onClick={() => setModalCrear(false)}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={handleCrearCentro} className="modal-crud-form">
                            <div className="form-grid-2">
                                <div className="form-field">
                                    <label>N° Correlativo (Opcional):</label>
                                    <input
                                        type="number"
                                        placeholder="Ej: 79"
                                        value={nuevoNro}
                                        onChange={e => setNuevoNro(e.target.value)}
                                    />
                                </div>
                                <div className="form-field">
                                    <label>Código DXN: <span className="req">*</span></label>
                                    <input
                                        type="text"
                                        placeholder="Ej: 360099887"
                                        value={nuevoCodigo}
                                        onChange={e => setNuevoCodigo(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Nombre del Director / Representante: <span className="req">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Ej: JUAN CARLOS PEREZ GOMEZ"
                                    value={nuevoDirector}
                                    onChange={e => setNuevoDirector(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-grid-2">
                                <div className="form-field">
                                    <label>Zona / Categoría: <span className="req">*</span></label>
                                    <select
                                        value={nuevaZona}
                                        onChange={e => setNuevaZona(e.target.value)}
                                        required
                                    >
                                        {zonas.map(z => (
                                            <option key={z.idZona} value={z.nombre_zona}>
                                                {z.nombre_zona}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-field">
                                    <label>Ciudad / Distrito:</label>
                                    <input
                                        type="text"
                                        placeholder="Ej: TINGO MARÍA, HUÁNUCO, etc."
                                        value={nuevaCiudad}
                                        onChange={e => setNuevaCiudad(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Ubicación / Dirección Completa: <span className="req">*</span></label>
                                <textarea
                                    rows="3"
                                    placeholder="Dirección, piso, urbanización y referencias..."
                                    value={nuevaUbicacion}
                                    onChange={e => setNuevaUbicacion(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-field">
                                <label>Información de Contacto (Teléfonos, Celulares, Correos):</label>
                                <textarea
                                    rows="2"
                                    placeholder="Oficina: 062-123456 | Celular: 987654321 | contacto@email.com"
                                    value={nuevoContacto}
                                    onChange={e => setNuevoContacto(e.target.value)}
                                />
                            </div>

                            <div className="form-field">
                                <label>Horario de Atención:</label>
                                <textarea
                                    rows="2"
                                    placeholder="Lunes a viernes de: 9:00am - 1:00pm, 3:00pm - 7:00pm"
                                    value={nuevoHorario}
                                    onChange={e => setNuevoHorario(e.target.value)}
                                />
                            </div>

                            <div className="modal-crud-footer">
                                <button
                                    type="button"
                                    className="btn-cancelar"
                                    onClick={() => setModalCrear(false)}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="btn-guardar"
                                    disabled={guardandoCentro}
                                >
                                    <FontAwesomeIcon icon={faSave} /> {guardandoCentro ? 'Guardando...' : 'Guardar Centro'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ========================================================= */}
            {/* MODAL EDITAR CENTRO                                       */}
            {/* ========================================================= */}
            {modalEditar && (
                <div className="modal-crud-overlay" onClick={() => setModalEditar(false)}>
                    <div className="modal-crud-content" onClick={e => e.stopPropagation()}>
                        <div className="modal-crud-header">
                            <h3><FontAwesomeIcon icon={faEdit} /> Editar Centro de Servicio</h3>
                            <button
                                type="button"
                                className="btn-close-modal"
                                onClick={() => setModalEditar(false)}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={handleEditarCentro} className="modal-crud-form">
                            <div className="form-grid-2">
                                <div className="form-field">
                                    <label>N° Correlativo:</label>
                                    <input
                                        type="number"
                                        value={editNro}
                                        onChange={e => setEditNro(e.target.value)}
                                    />
                                </div>
                                <div className="form-field">
                                    <label>Código DXN: <span className="req">*</span></label>
                                    <input
                                        type="text"
                                        value={editCodigo}
                                        onChange={e => setEditCodigo(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Nombre del Director / Representante: <span className="req">*</span></label>
                                <input
                                    type="text"
                                    value={editDirector}
                                    onChange={e => setEditDirector(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-grid-2">
                                <div className="form-field">
                                    <label>Zona / Categoría: <span className="req">*</span></label>
                                    <select
                                        value={editZona}
                                        onChange={e => setEditZona(e.target.value)}
                                        required
                                    >
                                        {zonas.map(z => (
                                            <option key={z.idZona} value={z.nombre_zona}>
                                                {z.nombre_zona}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-field">
                                    <label>Ciudad / Distrito:</label>
                                    <input
                                        type="text"
                                        value={editCiudad}
                                        onChange={e => setEditCiudad(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Ubicación / Dirección Completa: <span className="req">*</span></label>
                                <textarea
                                    rows="3"
                                    value={editUbicacion}
                                    onChange={e => setEditUbicacion(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-field">
                                <label>Información de Contacto:</label>
                                <textarea
                                    rows="2"
                                    value={editContacto}
                                    onChange={e => setEditContacto(e.target.value)}
                                />
                            </div>

                            <div className="form-field">
                                <label>Horario de Atención:</label>
                                <textarea
                                    rows="2"
                                    value={editHorario}
                                    onChange={e => setEditHorario(e.target.value)}
                                />
                            </div>

                            <div className="modal-crud-footer">
                                <button
                                    type="button"
                                    className="btn-cancelar"
                                    onClick={() => setModalEditar(false)}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="btn-guardar"
                                    disabled={actualizandoCentro}
                                >
                                    <FontAwesomeIcon icon={faSave} /> {actualizandoCentro ? 'Actualizando...' : 'Actualizar Cambios'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ========================================================= */}
            {/* MODAL CREAR ZONA                                          */}
            {/* ========================================================= */}
            {modalCrearZona && (
                <div className="modal-crud-overlay" onClick={() => setModalCrearZona(false)}>
                    <div className="modal-crud-content modal-small" onClick={e => e.stopPropagation()}>
                        <div className="modal-crud-header">
                            <h3><FontAwesomeIcon icon={faPlus} /> Agregar Nueva Zona</h3>
                            <button
                                type="button"
                                className="btn-close-modal"
                                onClick={() => setModalCrearZona(false)}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={handleCrearZona} className="modal-crud-form">
                            <div className="form-field">
                                <label>Nombre de la Zona: <span className="req">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Ej: Lima - Cono Norte, Provincias Selva, etc."
                                    value={nombreNuevaZona}
                                    onChange={e => setNombreNuevaZona(e.target.value)}
                                    required
                                    autoFocus
                                />
                            </div>

                            <div className="modal-crud-footer">
                                <button
                                    type="button"
                                    className="btn-cancelar"
                                    onClick={() => setModalCrearZona(false)}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="btn-guardar"
                                    disabled={guardandoZona}
                                >
                                    <FontAwesomeIcon icon={faSave} /> {guardandoZona ? 'Guardando...' : 'Guardar Zona'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ========================================================= */}
            {/* MODAL EDITAR ZONA                                         */}
            {/* ========================================================= */}
            {modalEditarZona && (
                <div className="modal-crud-overlay" onClick={() => setModalEditarZona(false)}>
                    <div className="modal-crud-content modal-small" onClick={e => e.stopPropagation()}>
                        <div className="modal-crud-header">
                            <h3><FontAwesomeIcon icon={faEdit} /> Editar Zona</h3>
                            <button
                                type="button"
                                className="btn-close-modal"
                                onClick={() => setModalEditarZona(false)}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={handleEditarZona} className="modal-crud-form">
                            <div className="form-field">
                                <label>Nombre de la Zona: <span className="req">*</span></label>
                                <input
                                    type="text"
                                    value={nombreEditZona}
                                    onChange={e => setNombreEditZona(e.target.value)}
                                    required
                                    autoFocus
                                />
                                <span className="helper-note">
                                    Nota: Al modificar el nombre de la zona, todos los centros asignados a ella se actualizarán automáticamente.
                                </span>
                            </div>

                            <div className="modal-crud-footer">
                                <button
                                    type="button"
                                    className="btn-cancelar"
                                    onClick={() => setModalEditarZona(false)}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="btn-guardar"
                                    disabled={actualizandoZona}
                                >
                                    <FontAwesomeIcon icon={faSave} /> {actualizandoZona ? 'Actualizando...' : 'Actualizar Zona'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
